import { useBranchLimits } from "@tlc/ls2pac/components/BranchLimits";
import { useSearchParams } from "react-router-dom";
import {
  LocationDialog,
  LocationSummary,
} from "@tlc/ls2pac/components/LocationDialog";
import React, { useMemo, useRef } from "react";
import { ListItem, ListItemButton, ListItemText } from "@mui/material";
import { useLanguage } from "@tlc/ls2pac/components/Language";
import { useDialog } from "@tlc/ui/dialog/useDialog";
import { useSkipLinks } from "../../../../hooks/useSkipLinks";

export const LocationFilterControl = () => {
  const { branchLimits, displayBranchLimitControl, selectedBranchIds } =
    useBranchLimits();
  const { open, closeDialog, openDialog } = useDialog();
  const [_, setSearchParams] = useSearchParams();
  const { translate } = useLanguage();

  if (!displayBranchLimitControl) {
    return null;
  }

  const filtersContainerRef = useRef<HTMLDivElement>(null);

  const skipLinks = useMemo(() => {
    return [
      {
        label: translate("SkipToFilters"),
        targetRef: filtersContainerRef,
        priority: 15,
      },
    ];
  }, [translate]);

  useSkipLinks(skipLinks);

  return (
    <ListItem sx={{ px: 0 }}>
      <LocationDialog
        open={open}
        onSubmit={(data) => {
          setSearchParams((prev) => {
            // TODO move this to LSSearch
            const newParams = new URLSearchParams(prev);
            newParams.delete("page");
            if (!data || data.length === 0) {
              newParams.set("branchFilters", JSON.stringify([])); // need to explicitly set to [] to clear because of context fallback
            } else {
              newParams.set("branchFilters", JSON.stringify(data));
            }

            return newParams;
          });
          closeDialog();
        }}
        onClose={closeDialog}
      ></LocationDialog>
      <ListItemButton
        ref={filtersContainerRef}
        sx={{ gap: 2 }}
        onClick={openDialog}
        divider={true}
        aria-haspopup="dialog"
        aria-controls="select-location-dialog"
      >
        <ListItemText
          primary={translate("selectedLocations")}
          secondaryTypographyProps={{ color: "secondary" }}
          secondary={
            <LocationSummary
              branchLimits={branchLimits}
              selected={selectedBranchIds}
            />
          }
          sx={{ my: 0 }}
        />
        {/* {<ChevronRightIcon />} */}
      </ListItemButton>
    </ListItem>
  );
};
